import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKayakingNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12.503 12.625l22.873 22.872a5.43 5.43 0 00.841 6.592l.38.38A8.645 8.645 0 0042.709 45h1.247c3.474 0 5.214-4.2 2.758-6.657l-3.931-3.931a4.645 4.645 0 00-5.198-.948l-1.888-1.888C44.565 21.544 47.168 10.05 47.931 4.59c.376-2.685-1.833-4.897-4.52-4.523-5.457.76-16.946 3.358-26.987 12.236l-1.888-1.888a4.644 4.644 0 00-.948-5.198l-3.93-3.93C7.2-1.17 3 .57 3 4.044v1.247c0 2.293.91 4.491 2.532 6.113l.38.38a5.43 5.43 0 006.591.84zm31.322-9.587c.713-.099 1.235.423 1.135 1.136-.72 5.149-3.168 15.897-11.389 25.277l-2.238-2.239c1.216-1.478 1.794-3.147 1.735-4.833-.067-1.926-.958-3.704-2.35-5.096s-3.17-2.284-5.097-2.351c-1.685-.059-3.354.52-4.833 1.735L18.55 14.43c9.388-8.231 20.13-10.675 25.275-11.39zm-20.9 15.766c.893-.662 1.782-.902 2.592-.874 1.042.036 2.128.523 3.08 1.474.95.951 1.437 2.038 1.473 3.08.028.809-.211 1.698-.873 2.592zm21.667 21.66c.567.567.166 1.536-.636 1.536h-1.247a5.644 5.644 0 01-3.99-1.653l-.38-.38a2.429 2.429 0 010-3.434 1.643 1.643 0 012.323 0zM6 4.044c0-.801.97-1.203 1.536-.636l3.931 3.93a1.643 1.643 0 010 2.324 2.428 2.428 0 01-3.434 0l-.38-.38A5.644 5.644 0 016 5.291z" />
        <path d="M26.532 30.896l-2.24-2.24c-.814.378-1.65.7-2.474.975-2.3.764-4.213-1.148-3.449-3.449.274-.825.597-1.66.975-2.474l-2.24-2.24a25.379 25.379 0 00-1.581 3.768c-1.543 4.645 2.596 8.784 7.24 7.242a25.396 25.396 0 003.77-1.582z" />
        <path d="M3.04 43.826c.716-5.124 3.146-15.798 11.276-25.146l-2.127-2.126C3.413 26.555.83 37.975.07 43.41c-.375 2.685 1.834 4.897 4.52 4.523 5.434-.756 16.848-3.336 26.858-12.123l-2.126-2.126C19.963 41.825 9.296 44.25 4.175 44.963c-.713.099-1.235-.423-1.135-1.137z" />
      </g>
    </svg>
  )
);
SvgSportsKayakingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKayakingNormalLarge;
